/*
 * ThryvApi (window.ThryvApi, and window.OneMind through it).
 *
 * THE NATIVE MODULE, BUNDLED HERE — not a legacy copy of it. resources/js/app/thryv-api is plain ES
 * modules with no Alpine, Vite or import.meta, so rollup takes the same source the native theme
 * uses. Native assets are gated behind RenderMode::isNativeRequest(), so without this a legacy
 * page-builder page has no ThryvApi at all.
 *
 * ONE SOURCE, DELIBERATELY. The alternative is a second implementation under src2 — which is exactly
 * what src2/1mind is, and whose native twin warns: "DEPLOYMENT IDS AND THE FIELD MAP EXIST IN BOTH
 * PLACES. When 1Mind changes an id, change it here AND in legacy/src2/1mind/Config.js."
 */
import "./ThryvApi/index.js";

import ThryvHubspot from "./controllers/ThryvHubspot/main";
import EventifyDOM from "./controllers/EventifyDOM";
import ExternalLinksIdentifier from "./controllers/ExternalLinksIdentifier";

window.v2ScriptsVersion = "1.0.6";

DOMReady(function () {
  EventifyDOM.init();

  ExternalLinksIdentifier.init();
});
